import { Component, inject, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { CopyrightDetails } from '@siemens/element-ng/copyright-notice';
import { SiLandingPageComponent } from '@siemens/element-ng/landing-page';

import { AccountService } from '../main/shared/services/account.service';
import { SettingsService } from '../main/shared/services/settings.service';
import { ShareDataService } from '../main/shared/services/share-data.service';

@Component({
  selector: 'app-login-page',
  imports: [SiLandingPageComponent, TranslateModule, FormsModule],
  templateUrl: './login-page.component.html',
  styleUrl: './login-page.component.scss'
})
export class LoginPageComponent implements OnInit {
  private readonly settingsService = inject(SettingsService);
  private readonly sharedDataService = inject(ShareDataService);
  private readonly accountService = inject(AccountService);

  applicationTitle = '';
  applicationClaim = '';

  ngOnInit() {
    this.applicationTitle = this.sharedDataService.getApplicationTitle();
    this.applicationClaim = this.sharedDataService.getApplicationClaim();
  }

  onLoginClicked() {
    this.accountService.loginViaRedirect();
  }

  availableLanguages = this.settingsService.availableLanguages;

  copyrightDetails: CopyrightDetails = {
    startYear: 2023,
    lastUpdateYear: 2025,
    company: 'Siemens Mobility'
  };
}
